import Ajax from './ajax';




//登录
export const Login = (data)=>{
    return Ajax.post('/api/Login/UserLogin',data)
}

//登录验证
export const LoginToGetCompanys = (data)=>{
    return Ajax.post('/api/Login/LoginToGetCompanys',data)
}


//登录验证
export const optorders = (data)=>{
    return Ajax.get('/back/shopify/optorders',data)
}

//添加或更新角色
export const AddOrUpdateRoles = (data)=>{
    return Ajax.post('/api/Role/AddOrUpdateRoles',data)
}

//为角色授权
export const SetRoleAuthorities = (data)=>{
    return Ajax.post('/api/Authority/SetRoleAuthorities',data)
}

//获取角色列表
export const GetCurUserAllRoleList = (data)=>{
    return Ajax.get('/api/Role/GetCurUserAllRoleList',data)
}

//删除角色
export const RemoveRoles = (data)=>{
    return Ajax.post('/api/Role/RemoveRoles',data)
}

//添加用户
export const SetUser = (data)=>{
    return Ajax.post('/api/BackUser/SetUser',data)
}

//添加用户
export const AddUser = (data)=>{
    return Ajax.post('/api/BackUser/AddUser',data)
}

//通过id获取店铺
export const GetAimUserShopList = (data)=>{
    return Ajax.get('/api/ShopUserRalation/GetAimUserShopList',data)
}


//获取当前登录用户的下属成员
export const GetAllUser = (data)=>{
    return Ajax.get('/api/BackUser/GetAllUser',data)
}

//为用户授予角色
export const GrantRoleToUser = (data)=>{
    return Ajax.post('/api/Role/GrantRoleToUser',data)
}

//为用户授予角色
export const GetOwnAuthorityList = (data)=>{
    return Ajax.get('/api/Authority/GetOwnAuthorityList',data)
}

//获取全部店铺列表
export const GetAllShopListOfShopify = (data)=>{
    return Ajax.get('/api/ShopUserRalation/GetAllShopListOfShopify',data)
}

//添加用户与商店关系表
export const AddShopUserRalation = (data)=>{
    return Ajax.post('/api/ShopUserRalation/AddShopUserRalation',data)
}

//获取自己管理的店铺列表
export const GetOwnShopListOfShopify = (data)=>{
    return Ajax.get('/api/ShopUserRalation/GetOwnShopListOfShopify',data)
}

//删除用户管理店铺关系 
export const RemoveShopUserRalation = (data)=>{
    return Ajax.post('/api/ShopUserRalation/RemoveShopUserRalation',data)
}

//获取角色的权限 
export const GetRoleAuthoritiesByRoleId = (data)=>{
    return Ajax.get(`/api/Role/GetRoleAuthoritiesByRoleId`,data)
}

//获取订单列表 
export const GetOrder = (data)=>{
    return Ajax.post(`/api/ShopifyOrder/GetOrder`,data)
}

//获取发货状态
export const ShopifyOrder = (data)=>{
    return Ajax.get(`/api/ShopifyOrder/ShopifyOrder`,data)
}

//获取下拉商店列表
export const GetShopDropList = (data)=>{
    return Ajax.get(`/api/ShopifyOrder/GetShopDropList`,data)
}

//获取订单发送国家
export const GetOrderCountry = (data)=>{
    return Ajax.get(`/api/ShopifyOrder/GetOrderCountry`,data)
}

//获取订单正常和错误的各种类型
export const GetTrouOrderType = (data)=>{
    return Ajax.get(`/api/ShopifyOrder/GetTrouOrderType`,data)
}

//获取订单状态
export const GetOrderFlowDrop = (data)=>{
    return Ajax.get(`/api/ShopifyOrder/GetOrderFlowDrop`,data)
}
//设置用户角色
export const SetUserRoles = (data)=>{
    return Ajax.post(`/api/Role/SetUserRoles`,data)
}

//获取Sku列表页信息
export const GetSkuList = (data)=>{
    return Ajax.get(`/api/Sku/GetSkuList`,data)
}

//更新Sku信息
export const UpdateSkuInfo = (data)=>{
    return Ajax.post(`/api/Sku/UpdateSkuInfo`,data)
}

export const GetOrderDetail = (data)=>{
    return Ajax.get(`/api/ShopifyOrder/GetOrderDetail`,data)
}

export const GetSkuIsTotalStockShow = (data)=>{
    return Ajax.get(`/api/Sku/GetSkuIsTotalStockShow`,data)
}

export const AddOrUpdateAdvertisementAccount = (data)=>{
    return Ajax.post(`/api/Advertisement/AddOrUpdateAdvertisementAccount`,data)
}

export const GetAllAdvertisementList = (data)=>{
    return Ajax.get(`/api/Advertisement/GetAllAdvertisementList`,data)
}

export const UpdateAdvertisementAccountStatus = (data)=>{
    return Ajax.post(`/api/Advertisement/UpdateAdvertisementAccountStatus`,data)
}

export const DepositToAccount = (data)=>{
    return Ajax.post(`/api/Advertisement/DepositToAccount`,data)
}

export const GetAllAdvertisementListDropList = (data)=>{
    return Ajax.get(`/api/Advertisement/GetAllAdvertisementListDropList`,data)
}

export const AdvertisementReportList = (data)=>{
    return Ajax.post(`/api/Advertisement/AdvertisementReportList`,data)
}

export const AddOrUpdateAdvertisementReport = (data)=>{
    return Ajax.post(`/api/Advertisement/AddOrUpdateAdvertisementReport`,data)
}

export const GetOwnAdvertisementAccountShowInfo = (data)=>{
    return Ajax.get(`/api/Advertisement/GetOwnAdvertisementAccountShowInfo`,data)
}
export const GetCanSeeReportUserInfo = (data)=>{
    return Ajax.get(`/api/Advertisement/GetCanSeeReportUserInfo`,data)
}

//获取广告账户类型
export const GetAdvertisementTypeDropList = (data)=>{
    return Ajax.get(`/api/Advertisement/GetAdvertisementTypeDropList`,data)
}

//更新用户状态
export const UpdateUserStatus = (data)=>{
    return Ajax.post(`/api/BackUser/UpdateUserStatus`,data)
}

//获取过滤条件
export const GetBillFilterDropList = (data)=>{
    return Ajax.get(`/api/Advertisement/GetBillFilterDropList`,data)
}

//获取广告账户明细
export const AdvertisementAccountBillList = (data)=>{
    return Ajax.post(`/api/Advertisement/AdvertisementAccountBillList`,data)
}

//获取店铺负责人下拉列表
export const GetShopManagers = (data)=>{
    return Ajax.get(`/api/OperateData/GetShopManagers`,data)
}

//更新运营数据
export const UpdateOperateData  = (data)=>{
    return Ajax.post(`/api/OperateData/UpdateOperateData `,data)
}

//获取运营数据
export const OperateDataInfo  = (data)=>{
    return Ajax.post(`/api/OperateData/OperateDataInfo`,data)
}

//获取运营配置
export const GetOperateConfig  = (data)=>{
    return Ajax.get(`/api/OperateData/GetOperateConfig`,data)
}
//更新运营配置
export const UpdateOperateConfig   = (data)=>{
    return Ajax.post(`/api/OperateData/UpdateOperateConfig `,data)
}
//获取运费分页列表

export const GetTransportRulesPage = (data)=>{
    return Ajax.get(`/api/Transport/GetTransportRulesPage`,data)
}
//添加或修改运费规则
export const AddOrUpdateTransportRuleConfig = (data)=>{
    return Ajax.post(`/api/Transport/AddOrUpdateTransportRuleConfig`,data)
}

//绑定店铺
export const AddShop = (data)=>{
    return Ajax.post(`/api/ShopifyShop/AddShop`,data)
}


//争议
export const AllDisputes = (data)=>{
    return Ajax.post(`/api/Dispute/AllDisputes`,data)
}
export const GetCurDisputeAllAttachUser = (data)=>{
    return Ajax.get(`/api/Dispute/GetCurDisputeAllAttachUser`,data)
}
export const GetCurDisputeAllStatus = (data)=>{
    return Ajax.get(`/api/Dispute/GetCurDisputeAllStatus`,data)
}
export const GetCurDisputeAllReason = (data)=>{
    return Ajax.get(`/api/Dispute/GetCurDisputeAllReason`,data)
}
export const GetDisputeDetail = (data)=>{
    return Ajax.get(`/api/Dispute/GetDisputeDetail`,data)
}
export const AddMsg = (data)=>{
    return Ajax.post(`/api/Dispute/AddMsg`,data)
}

export const AddShopifyShopAuth = (data)=>{
    return Ajax.post(`/api/ShopifyShop/AddShopifyShopAuth`,data)
}

export const RegistPhone = (data)=>{
    return Ajax.post(`/api/Login/RegistPhone`,data)
}

export const RegistCompanyByPhone = (data)=>{
    return Ajax.post(`/api/Login/RegistCompanyByPhone`,data)
}

export const GetUserHeaderInfo = (data)=>{
    return Ajax.get(`/api/BackUser/GetUserHeaderInfo`,data)
}

export const UpdateShopifyShopPaypal = (data)=>{
    return Ajax.post(`/api/ShopifyShop/UpdateShopifyShopPaypal`,data)
}

export const GetAllCompanyInfo = (data)=>{
    return Ajax.get(`/api/BackUser/GetAllCompanyInfo`,data)
}

export const EditUserPassword = (data)=>{
    return Ajax.post(`/api/BackUser/EditUserPassword`,data)
}

export const GetCurCompanyAttachTransChannel=(data)=>{
    return Ajax.get("/back/k5/GetCurCompanyAttachTransChannel",data)
}

export const GetSdkList=(data)=>{
    return Ajax.get("/back/k5/GetSdkList",data)
}

export const GetAllTransChannel=(data)=>{
    return Ajax.get("/back/k5/GetAllTransChannel",data)
}

export const UserManagerSetTransSdk=(data)=>{
    return Ajax.post("/back/k5/UserManagerSetTransSdk",data)
}

export const AdminSetTransSdk=(data)=>{
    return Ajax.post("/back/k5/AdminSetTransSdk",data)
}

export const GetChukouEClientId=(data)=>{
    return Ajax.get("/api/Auth2/GetChukouEClientId",data)
}

export const GetChukouECallBackUrl=(data)=>{
    return Ajax.get("/api/Auth2/GetChukouECallBackUrl",data)
}
export const PostChukouECode=(data)=>{
    return Ajax.post("/api/Auth2/PostChukouECode",data)
}






















